export const fuelInputs = [
  'machineId',
  'name',
  'location',
  'description',
  'startDate',
  'endDate',
  //   'breakdownDetails',
]

export const addFuelTaskInitialState = {
  machineId: null,
  name: null,
  startDate: null,
  endDate: null,
  location: null,
  description: null,
  trips: [],
  breakdownType: null,
  breakdownStartDate: null,
  breakdownEndDate: null,
  breakdownDetails: null,
}

export const fuelTypes = [
  { value: 1, label: 'Diesel' },
  { value: 2, label: 'Benzine' },
  { value: 3, label: 'Gas' },
]

export const fuelTypeSelect = (fuelType: number | null | undefined) => {
  if (fuelType == null) return null
  const opt = fuelTypes.find((t) => t.value === fuelType)
  return { value: fuelType, label: opt?.label || String(fuelType) }
}

export const parseFuelTankOptions = (data: any) =>
  (data?.data || data || []).map((item: any) => ({
    label: item.name,
    value: item.id,
    fuelType: item.fuelType,
    currentAmount: item.currentAmount,
    capacity: item.capacity,
  }))

export const fuelDeliveryRequestStatuses = [
  { value: 1, label: 'Requested' },
  { value: 2, label: 'In Procurement' },
  { value: 3, label: 'Partially Received' },
  { value: 4, label: 'Received' },
  { value: 5, label: 'Partially Fulfilled' },
  { value: 6, label: 'Fulfilled' },
  { value: 7, label: 'Cancelled' },
]

export const fuelDeliveryRequestStatusLabel = (status: number) =>
  fuelDeliveryRequestStatuses.find((s) => s.value === status)?.label || String(status)

export const fuelDeliveryFuelTypeLabel = (fuelType: number) =>
  fuelTypes.find((t) => t.value === fuelType)?.label || String(fuelType)


export const fuelConsumptionPeriods = [
  { value: 1, label: '12 Months' },
  { value: 2, label: '30 Days' },
  { value: 3, label: '7 Days' },
  { value: 4, label: '24 hours' },
]

export const fuelAlertRiskLevels = ['None', 'Low', 'Medium', 'High']

export const fuelAlertPriorities = ['Low', 'Medium', 'High', 'Critical']

export const fuelLossCaseStatuses = [
  { value: 1, label: 'Open' },
  { value: 4, label: 'Under investigation' },
  { value: 2, label: 'Pending approval' },
  { value: 3, label: 'Closed' },
]

export const fuelLossSeverities = [
  { value: 1, label: 'Critical' },
  { value: 2, label: 'Warning' },
]

export const fuelLossRootCauses = [
  { value: 1, label: 'Meter / dispenser drift' },
  { value: 2, label: 'Dip / measurement error' },
  { value: 3, label: 'Data entry error' },
  { value: 4, label: 'Leak or spillage' },
  { value: 5, label: 'Theft / unauthorized draw' },
  { value: 6, label: 'Unrecorded dispense' },
  { value: 7, label: 'Temperature / evaporation' },
  { value: 8, label: 'Other' },
]

export const fuelLossOutcomes = [
  { value: 1, label: 'Recovered' },
  { value: 2, label: 'Written off' },
  { value: 3, label: 'Disciplinary' },
]

export const fuelLossRootCauseLabel = (value: number | null | undefined) =>
  fuelLossRootCauses.find((s) => s.value === value)?.label || '—'

export const fuelLossAuditEventLabel = (eventType: number) => {
  switch (eventType) {
    case 115:
      return 'Owner assigned'
    case 116:
      return 'Status changed'
    case 117:
      return 'Note added'
    case 118:
      return 'Write-off approved'
    case 119:
      return 'Write-off rejected'
    case 120:
      return 'Auto-closed'
    default:
      return `Event ${eventType}`
  }
}
